export type CommunityMember = {
  id: string;
  alias: string;
  initials: string;
  color: string;
  flowPoints: number;
  activeDays: number;
  movement: number;
  isCurrentUser?: boolean;
};

export type CommunityCelebration = {
  id: string;
  alias: string;
  initials: string;
  color: string;
  message: string;
  timeAgo: string;
  kind: 'streak' | 'repertoire' | 'tier';
};

export const communityMembers: CommunityMember[] = [
  {
    id: 'bright-cadence',
    alias: 'Bright Cadence',
    initials: 'BC',
    color: '#CA7C62',
    flowPoints: 820,
    activeDays: 4,
    movement: 2,
  },
  {
    id: 'silver-sonata',
    alias: 'Silver Sonata',
    initials: 'SS',
    color: '#6F87F1',
    flowPoints: 765,
    activeDays: 4,
    movement: 0,
  },
  {
    id: 'steady-tempo',
    alias: 'Steady Tempo',
    initials: 'ST',
    color: '#4FA98A',
    flowPoints: 710,
    activeDays: 3,
    movement: -1,
  },
  {
    id: 'you',
    alias: 'Moonlit Melody',
    initials: 'MM',
    color: '#C6A7F5',
    flowPoints: 640,
    activeDays: 2,
    movement: 3,
    isCurrentUser: true,
  },
  {
    id: 'gentle-arpeggio',
    alias: 'Gentle Arpeggio',
    initials: 'GA',
    color: '#E3A85E',
    flowPoints: 595,
    activeDays: 3,
    movement: 1,
  },
  {
    id: 'blue-chord',
    alias: 'Blue Chord',
    initials: 'BC',
    color: '#5DA7D9',
    flowPoints: 530,
    activeDays: 2,
    movement: -2,
  },
  {
    id: 'quiet-octave',
    alias: 'Quiet Octave',
    initials: 'QO',
    color: '#8F9BB3',
    flowPoints: 485,
    activeDays: 2,
    movement: 0,
  },
];

export const communityCelebrations: CommunityCelebration[] = [
  {
    id: 'celebration-1',
    alias: 'Steady Tempo',
    initials: 'ST',
    color: '#4FA98A',
    message: 'reached a 7-day practice streak',
    timeAgo: '18 min ago',
    kind: 'streak',
  },
  {
    id: 'celebration-2',
    alias: 'Gentle Arpeggio',
    initials: 'GA',
    color: '#E3A85E',
    message: 'made progress on Clair de Lune',
    timeAgo: '1 hr ago',
    kind: 'repertoire',
  },
  {
    id: 'celebration-3',
    alias: 'Bright Cadence',
    initials: 'BC',
    color: '#CA7C62',
    message: 'completed a new tier for the first time',
    timeAgo: '3 hrs ago',
    kind: 'tier',
  },
];

export const weeklyChallenge = {
  title: 'Find your rhythm',
  description: 'Practice on 3 different days this week.',
  completedDays: 2,
  targetDays: 3,
  reward: 'Rhythm Keeper badge',
};

export const getCurrentMemberRank = () => {
  const index = communityMembers.findIndex((member) => member.isCurrentUser);
  return index === -1 ? null : index + 1;
};
